<div class="full-screen">
  <iframe [src]="externalLink | liveVimeoUrl" width="100%" height="100%"
    frameborder="0"></iframe>
</div>
